export default "__VITE_ASSET__30da0e8e__"